import React, { Suspense } from 'react'
import { BrowserRouter, Switch } from 'react-router-dom'
import { renderRoutes } from './routes'
import './App.css'
import 'antd/dist/antd.css'
import RouteWrapper from './components/RouteWrapper.js/RouteWrapper'
import NoInternetConnection from './components/NoInternet/NoInternet'

function App() {
  return (
    <div className="App">
      <Suspense fallback={<div className="loding">Loading...</div>}>
        <NoInternetConnection>
          <BrowserRouter>
            <div>
              {/* <NavLink to={routes.dashboard.path} activeClassName="class">Dashboard</NavLink>
          <NavLink to={routes.about.path} activeClassName="class">About</NavLink> */}
            </div>
            <Switch>
              {renderRoutes.map(([key, route]) => (
                <RouteWrapper key={key} {...route} />
              ))}
            </Switch>
          </BrowserRouter>
        </NoInternetConnection>
      </Suspense>
    </div>
  )
}

export default App
